export class ComponentProjectChecklistItem {
  id: number;
  checklistId: number;
  itemName: string;
  checked: boolean;
  createdBy: string;
  updated: Date;
}
